var _circle, _circle2, _ellipse, _ellipse2, _path, _path2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4628,
    cy: 26,
    r: 26,
    fill: "#DFDFDF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5736,
    cy: 25.8888,
    r: 14.9679,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9607,
    cy: 28.9854,
    rx: 1.03227,
    ry: 1.5484,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.2188,
    cy: 28.9854,
    rx: 1.03227,
    ry: 1.5484,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1542 32.5986H24.7671C24.7671 33.6309 25.5413 34.4051 27.0897 34.4051C28.5495 34.4051 29.0682 33.2868 29.1542 32.5986Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7858 10.9214C15.3895 11.1472 11.9996 20.2118 11.6057 24.857H22.2408L22.6347 20.0791H24.2102L24.6041 24.4589H28.9369L29.3308 20.0791H30.9064L31.3003 24.4589H41.5414C41.0253 19.6956 37.6704 10.6634 25.7858 10.9214Z",
    fill: "#202123"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9929,
    cy: 13.7548,
    r: 3.35487,
    fill: "#202123"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.6381,
    cy: 13.7548,
    r: 3.35487,
    fill: "#202123"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile9);
export default __webpack_public_path__ + "static/media/img_profile_9.8828d2c6eb78f515392d447a180a1243.svg";
export { ForwardRef as ReactComponent };